import React from 'react';
import { Link } from 'react-router-dom';
import DocsGuide from '../Components/Docs/DocsGuide';

const GUIDES = [
  {
    to: '/embed',
    title: 'Embed an experience',
    description: 'Add an existing MagicFurnish experience to a website or listing.',
  },
  {
    to: '/create',
    title: 'Create an experience',
    description: 'Generate a hosted experience from a 2D floor plan.',
  },
];

const Arrow = () => (
  <svg className="docs-portal-arrow" viewBox="0 0 16 16" width="14" height="14" aria-hidden="true">
    <path
      d="M3 8h10M9 4l4 4-4 4"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const DocsIndex = () => (
  <DocsGuide
    documentTitle="MagicFurnish Docs"
    navGroups={[]}
    showNav={false}
    lastUpdated="November 4, 2026"
  >
    <article className="docs-portal">
      <header className="docs-portal-hero">
        <h1>Documentation</h1>
        <p className="docs-portal-lead">
          Integrate floor plan try-on into property websites, listings, or applications.
        </p>
      </header>

      <section className="docs-portal-section" aria-labelledby="integration-guides">
        <h2 id="integration-guides">Integration guides</h2>
        <nav className="docs-portal-rows" aria-label="Guides">
          {GUIDES.map((guide) => (
            <Link key={guide.to} className="docs-portal-row" to={guide.to}>
              <span className="docs-portal-row-copy">
                <span className="docs-portal-row-title">{guide.title}</span>
                <span className="docs-portal-row-desc">{guide.description}</span>
              </span>
              <Arrow />
            </Link>
          ))}
        </nav>
      </section>

      <section className="docs-portal-section docs-portal-partner" aria-labelledby="partner-guides">
        <h2 id="partner-guides">Partner guides</h2>
        <Link className="docs-portal-partner-link" to="/smple">
          S.MPLE integration guide
          <Arrow />
        </Link>
      </section>
    </article>
  </DocsGuide>
);

export default DocsIndex;
